module.exports = __webpack_public_path__ + "assets/img/AZ_Icon.2c6c473b.png";